import { Button, Grid, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { faHeadphonesAlt } from "@fortawesome/free-solid-svg-icons";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { faFileImage } from "@fortawesome/free-solid-svg-icons";

const useStyles = makeStyles((theme) => ({
  fileName: {
    fontSize: 16,
    fontFamily: "Noto Sans KR",
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      fontSize: 14,
    },
  },
  iconContainer: {
    [theme.breakpoints.down("xs")]: {
      paddingRight: 16,
    },
  },
  hwpIcon: {
    width: 24,
    paddingTop: 4,
    [theme.breakpoints.down("xs")]: {
      height: 24,
    },
  },
}));

interface BoardListFileProps {
  file: any;
}

function GalleryFile({ file }: BoardListFileProps) {
  const classes = useStyles();
  const [mime, setMime] = useState<any>(null);
  const [url, setUrl] = useState<any>(null);
  const [fileName, setFileName] = useState<any>(null);
  useEffect(() => {
    if (file) {
      let type = file.mime;

      const typeTest = type.split("/");

      const fileLength = file.length;
      const lastDot = file.url.lastIndexOf(".");
      const fileExt = file.url.substring(lastDot, fileLength).toLowerCase();

      if (typeTest[0] == "application") {
        if (
          typeTest[1] == "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          setMime("spredsheet");
          setUrl(file.url);
          setFileName(file.name);
        } else if (typeTest[1] == "pdf") {
          setMime("pdf");
          setUrl(file.url);
          setFileName(file.name);
        } else if (typeTest[1] == "octet-stream") {
          if (fileExt == ".hwp") {
            setMime("hwp");
            setUrl(file.url);
            setFileName(file.name);
          } else {
            setMime("other");
            setUrl(file.url);
            setFileName(file.name);
          }
        } else {
          setMime("other");
          setUrl(file.url);
          setFileName(file.name);
        }
      }

      if (typeTest[0] == "image") {
        setMime("image");
        setUrl(file.url);
        setFileName(file.name);
      }

      if (typeTest[0] == "audio") {
        setMime("audio");
        setUrl(file.url);
        setFileName(file.name);
      }
    }
    return () => {
      setMime(null);
      setUrl(null);
      setFileName(null);
    };
  }, [file]);

  if (url && mime == "spredsheet") {
    return (
      <Grid xs={12} item container style={{ paddingTop: 4, paddingBottom: 4 }}>
        <Grid
          xs={1}
          item
          justify={"center"}
          container
          className={classes.iconContainer}
        >
          <FontAwesomeIcon
            icon={faFileExcel}
            style={{ color: "rgb(0 110 70)" }}
            size="2x"
          />
        </Grid>
        <Grid xs={11} item>
          <a href={`${url}`} download>
            <div className={classes.fileName}>{fileName}</div>{" "}
          </a>
        </Grid>
      </Grid>
    );
  } else if (url && mime == "hwp") {
    return (
      <Grid xs={12} item container style={{ paddingTop: 4, paddingBottom: 4 }}>
        <Grid
          xs={1}
          item
          justify={"center"}
          container
          className={classes.iconContainer}
        >
          <img
            src={`/images/support/file_icons/hanicon.png`}
            style={{ width: 24, paddingTop: 4 }}
            className={classes.hwpIcon}
          />
        </Grid>
        <Grid xs={11} item>
          <a href={`${url}`} download>
            <div className={classes.fileName}>{fileName}</div>
          </a>
        </Grid>
      </Grid>
    );
  } else if (url && mime == "audio") {
    return (
      <Grid xs={12} item container style={{ paddingTop: 4, paddingBottom: 4 }}>
        <Grid
          xs={1}
          item
          justify={"center"}
          container
          className={classes.iconContainer}
        >
          <FontAwesomeIcon
            icon={faHeadphonesAlt}
            style={{ color: "blue" }}
            size="2x"
          />
        </Grid>
        <Grid xs={11} item>
          <a href={`${url}`} download>
            <div className={classes.fileName}>{fileName}</div>
          </a>
        </Grid>
      </Grid>
    );
  } else if (url && mime == "image") {
    return (
      <Grid xs={12} item container style={{ paddingTop: 4, paddingBottom: 4 }}>
        <Grid
          xs={1}
          item
          justify={"center"}
          container
          className={classes.iconContainer}
        >
          <FontAwesomeIcon
            icon={faFileImage}
            style={{ color: "rgb(250 90 85)" }}
            size="2x"
          />
        </Grid>
        <Grid xs={11} item>
          <a href={`${url}`} download>
            <div className={classes.fileName}>{fileName}</div>
          </a>
        </Grid>
      </Grid>
    );
  } else if (url && mime == "pdf") {
    return (
      <Grid xs={12} item container style={{ paddingTop: 4, paddingBottom: 4 }}>
        <Grid
          xs={1}
          item
          justify={"center"}
          container
          className={classes.iconContainer}
        >
          <FontAwesomeIcon
            icon={faFilePdf}
            style={{ color: "rgb(180 10 15)" }}
            size="2x"
          />
        </Grid>
        <Grid xs={11} item>
          <a href={`${url}`} download>
            <div className={classes.fileName}>{fileName}</div>
          </a>
        </Grid>
      </Grid>
    );
  } else if (url && mime == "other") {
    return (
      <Grid xs={12} item container style={{ paddingTop: 4, paddingBottom: 4 }}>
        <Grid
          xs={1}
          item
          justify={"center"}
          container
          className={classes.iconContainer}
          // style={{ paddingTop: 2 }}
        >
          <AttachFileIcon style={{ fontSize: 28 }} />
        </Grid>
        <Grid xs={11} item>
          <a href={`${url}`} download>
            <div className={classes.fileName}>{fileName}</div>
          </a>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid xs={12} item container style={{ paddingTop: 4, paddingBottom: 4 }}>
        <Grid
          xs={1}
          item
          justify={"center"}
          container
          className={classes.iconContainer}
          // style={{ paddingTop: 2 }}
        >
          <AttachFileIcon style={{ fontSize: 28 }} />
        </Grid>
        <Grid xs={11} item>
          <a href={`${url}`} download>
            <div className={classes.fileName}>{fileName}</div>
          </a>
        </Grid>
      </Grid>
    );
  }
}

export default GalleryFile;
